import { useState } from 'react';

export const useModalState = (initialState = false) => {
  const [open, setOpen] = useState(initialState);
  const [data, setData] = useState();

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return { open, handleOpen, handleClose, data, setData };
};
